import React from "react";
import SportCode from "components/common/SportCode";
import { dateFormat } from "helpers/utils"
import ScoresLiveCard from "components/common/ScoresLiveCard";


export function Footer({ data, period, mirs_discipline }) {
    return <div className='scores-today-status'>{period === undefined && (data?.status?.description)} <SportCode discipline={mirs_discipline} entity='@Period' code={period} /></div>
}

export function Header({ data }) {
    return (
        <><div className='scores-today-header'>
            <div className='scores-today-piste'>{data?.location?.longDescription}</div>
            <div className='scores-today-unit-time'>
                <div className='flex-grow-1'>
                    {data?.eventUnit?.description}
                </div>
                <div className='text-end'>
                    {dateFormat(data?.startDate, undefined, 'HH:mm')}{ }
                </div>
            </div>
        </div></>
    )
}

export function CardsLayout({ results }) {

    return (<>
        <div className="scores-today-container">
            {results && results?.map(item => {
                return (<ScoresLiveCard data={item} key={item?.eventUnit?.code} />)
            })}
        </div>
    </>
    );
}